import React from "react"
import { Link } from "gatsby"
import { Navbar, Nav, Col, Row } from "react-bootstrap"
import AnchorLink from "react-anchor-link-smooth-scroll"

const CustomNavbar = ({ pageInfo }) => {
    var path;
    if(pageInfo && pageInfo.pageName && pageInfo.pageName === 'index'){
        path = '/';
    } else {
        path = '/' + (pageInfo && pageInfo.pageName)
    }

    return (
        <Row noGutters={true}>
            <Col md={{span: 12}} >
                <Navbar className='chines' variant="light" expand="lg" id="site-navbar">
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="mr-auto menu" activeKey={pageInfo && pageInfo.pageName}>
                            <Link to="/ch"  className="link-no-style">
                                <Nav.Link as="span" eventKey="jobs">
                                    主页
                                </Nav.Link>
                            </Link>
                            <Link to="/ch/about" className="link-no-style">
                                <Nav.Link as="span" eventKey="about">
                                    公司简介
                                </Nav.Link>
                            </Link>
                            <Link to="/ch" className="link-no-style">
                                <Nav.Link as="span" eventKey="jobs">
                                    {(pageInfo && pageInfo.pageName && pageInfo.pageName !== 'index' ? ' OEM-ODM' : <AnchorLink href='#oem-odm'>OEM-ODM</AnchorLink>)}
                                </Nav.Link>
                            </Link>
                            <Link to="/ch/events" className="link-no-style">
                                <Nav.Link as="span" eventKey="news">
                                    新闻动态
                                </Nav.Link>
                            </Link>
                            <Link to="/ch/contact" className="link-no-style">
                                <Nav.Link as="span" eventKey="contact">
                                    联系我们
                                </Nav.Link>
                            </Link>
                        </Nav>
                        <Nav className="auth-menu d-flex align-items-center align-items-lg-center align-items-sm-start pointer">
                            <Link to= {path}   className="link-no-style">
                                <Nav.Link as="span" eventKey="jobs" className={'ml10 mb10'} onClick={() => {localStorage.setItem("lang", 'en')}}>
                                    EN
                                </Nav.Link>
                            </Link>
                        </Nav>
                        <Link to="/ch/collection" className="link-no-style">
                            <Nav.Link as="span" eventKey="news">
                                <span className={'sample-btn'}>产品样品</span>
                            </Nav.Link>
                        </Link>
                    </Navbar.Collapse>
                </Navbar>
            </Col>
        </Row>
    )
}

export default CustomNavbar
